
class EnumArray extends Array {

    /**
     *
     * @param {string} key
     * @returns {string}
     */
    getLabelByKey(key) {
        const foundItem = this.getItemByKey(key);
        return foundItem?.label;
    }

    /**
     *
     * @param {string} key
     * @returns {object}
     */
    getItemByKey(key) {
        return this.find(item => item.key === key);
    }

}

export const SITUATIONS = new EnumArray(
    {
        key: 1,
        label: 'Ativo',
    },
    {
        key: 0,
        label: 'Inativo',
    },
);

export const RECURRENCE_PLAN = new EnumArray(
    {
        key: 'MONTHLY',
        label: 'Mensal',
    },
    {
        key: 'QUARTERLY',
        label: 'Trimestral',
    },
    {
        key: 'HALF_YEARLY',
        label: 'Semestral',
    },
    {
        key: 'YEARLY',
        label: 'Anual',
    },
);

export const PAYMENT_METHOD = new EnumArray(
    {
        key: 'BANK_SLIP',
        label: 'Boleto',
    },
    {
        key: 'CREDIT_CARD',
        label: 'Cartão de crédito',
    },
    {
        key: 'PIX',
        label: 'PIX',
    },
);

export const CUSTOMER_TYPES = new EnumArray(
    {
        key: 'INDIVIDUAL',
        label: 'Pessoa física',
    },
    {
        key: 'LEGAL_ENTITY',
        label: 'Pessoa jurídica',
    },
);

export const SUBSCRIPTION_STATUSES = new EnumArray(
    {
        key: 'AWAITING_TERMS_ACCEPTANCE',
        label: 'Aguardando aceite dos termos',
    },
    {
        key: 'AWAITING_PAYMENT',
        label: 'Aguardando pagamento',
    },
    {
        key: 'PROCESSING_PAYMENT',
        label: 'Processando pagamento',
    },
    {
        key: 'AWAITING_ACCESS',
        label: 'Aguardando acesso',
    },
    {
        key: 'ACTIVE',
        label: 'Ativo',
    },
    {
        key: 'CANCELED',
        label: 'Cancelado',
    },
    {
        key: 'PAYMENT_ERROR',
        label: 'Erro no pagamento',
    },
);

export const INTEGRATION_STATUSES = new EnumArray(
    {
        key: 'SUCCESS',
        label: 'Integrado com sucesso ao ERP',
    },
    {
        key: 'FAILED',
        label: 'Erro na integração ao ERP',
    }, 
);

export const CONTRACT_TERM_STATUSES = new EnumArray(
    {
        key: true,
        label: 'Ativo',
    },
    {
        key: false,
        label: 'Inativo',
    },
);

export const ASSISTED_PURCHASE_INTEGRATION_STATUSES = new EnumArray(
    {
        key: 'SUCCESS',
        label: 'Integrado com sucesso ao ERP',
    },
    {
        key: 'FAILED',
        label: 'Erro na integração ao ERP',
    }, 
);

export const ASSISTED_PURCHASE_STATUS = new EnumArray(
    {
        key: 'ACTIVE',
        label: 'Ativo',
    },
    {
        key: 'AWAITING_INSTANCE',
        label: 'Aguardando Instância',
    },
    {
        key: 'PROCESSING',
        label: 'Processando',
    },
    {
        key: 'CANCELED',
        label: 'Cancelado',
    },
    {
        key: 'FAILED',
        label: 'Falha de Processamento',
    },
    {
        key: 'INACTIVE',
        label: 'Inativo',
    },
);

export const ASSISTED_PURCHASE_PREVIEW_OPTIONS = new EnumArray(
    {
        key: true,
        label: 'Sim',
    },
    {
        key: false,
        label: 'Não',
    },
);

export const INTEGRATION_ERROR_MONITORING_TYPE = new EnumArray(
    { key: 'ALERT', label: 'Alerta' },
    { key: 'ERROR', label: 'Erro' },
);

export const INTEGRATION_ERROR_MONITORING_PROCESS_TYPE = new EnumArray(
    { key: 'MAPPING', label: 'Mapeamento' },
    { key: 'ERP_SYNCHRONIZATION', label: 'Sincronização com o ERP' },
    { key: 'COMPANY_SEARCH', label: 'Busca de empresa por id externo' },
    { key: 'CUSTOMER_CREATION', label: 'Criação do cliente' },
);

export const INTEGRATION_MAPPING_STATUSES = new EnumArray(
    {
        key: 'CONTRACT',
        label: 'Contrato',
    },
    {
        key: 'CALCULATION',
        label: 'Cálculo',
    },
    {
        key: 'ITEM',
        label: 'Item',
    },
    {
        key: 'DISCOUNT',
        label: 'Desconto',
    },
);

export const BILLING_PERIOD_OPTIONS = new EnumArray(
    {
        key: 'SINGLE',
        label: 'Fixo',
    },
    {
        key: 'MONTHLY',
        label: 'Mensal',
    },
);

export const DUE_DATE_BEHAVIORS = new EnumArray(
    {
        key: 'DUE_DATE_BEHAVIOR_SETUP',
        label: 'Setup',
    },
    {
        key: 'DUE_DATE_BEHAVIOR_MONTHLY',
        label: 'Mensalidade',
    },
    {
        key: 'DUE_DATE_BEHAVIOR_GRACE_PERIOD',
        label: 'Carência',
    },
);

export const REFERENCE_FIELD_OPTIONS_CREATE = [
    {
        label: 'Endereço',
        options: [
            { key: 'ADDRESS_ZIP_CODE', label: 'CEP' },
            { key: 'ADDRESS_STREET', label: 'Endereço' },
            { key: 'ADDRESS_NUMBER', label: 'Número (do endereço)' },
            { key: 'ADDRESS_COMPLEMENT', label: 'Complemento' },
            { key: 'ADDRESS_DISTRICT', label: 'Bairro' },
            { key: 'ADDRESS_CITY', label: 'Cidade' },
            { key: 'ADDRESS_STATE', label: 'Estado' },
            { key: 'ADDRESS_COUNTRY_CODE', label: 'Código do País' },
            { key: 'ADDRESS_COUNTRY_NAME', label: 'País' },
            { key: 'ADDRESS_IBGE_CODE', label: 'Código IBGE' },
        ],
    },
    { label: '', options: [] },
    {
        label: 'Contrato',
        options: [
            { key: 'CONTRACT_EMAIL', label: 'E-mail do Contrato' },
            { key: 'CONTRACT_SIGN_AT', label: 'Data de Assinatura do Contrato' },
            { key: 'CONTRACT_READJUSTMENT_CODE', label: 'Código de Reajuste' },
            { key: 'CONTRACT_CURRENCY_CODE', label: 'Moeda do Contrato' },
            { key: 'CONTRACT_PLAN_DESCRIPTION', label: 'Plano' },
            { key: 'CONTRACT_HUBSPOT_DEAL_ID', label: 'ID da negociação do Hubspot' },
        ],
    },
    { label: '', options: [] },
    {
        label: 'Cliente',
        options: [
            { key: 'CUSTOMER_TRADING_NAME', label: 'Nome Fantasia' },
            { key: 'CUSTOMER_NAME', label: 'Nome do Cliente' },
            { key: 'CUSTOMER_DOCUMENT_NUMBER', label: 'Número do Documento' },
            { key: 'ADDRESS_STATE_INSCRIPTION', label: 'Inscrição Estadual' },
            { key: 'CUSTOMER_EMAIL', label: 'E-mail do Cliente' },
            { key: 'CUSTOMER_PERSON_TYPE', label: 'Tipo de Pessoa' },
            { key: 'CUSTOMER_GENDER_TYPE', label: 'Gênero' },
            { key: 'CUSTOMER_RG_NUMBER', label: 'Número do RG' },
            { key: 'CUSTOMER_RG_EMISSION', label: 'Data de Emissão do RG' },
            { key: 'CUSTOMER_DOCUMENT_DISPATCHER', label: 'Órgão Emissor do Documento' },
            { key: 'CUSTOMER_DOCUMENT_TAX_REGIME_SIMPLES', label: 'Regime Tributário - Simples Nacional' },
            { key: 'CUSTOMER_FILLING_RESPONSIBLE_NAME', label: 'Nome do responsável pelo preenchimento' },
            { key: 'CUSTOMER_FILLING_RESPONSIBLE_ROLE', label: 'Cargo do responsável pelo preenchimento' },
            { key: 'CUSTOMER_LEGAL_REPRESENTATIVE_NAME', label: 'Nome do representante legal' },
            {
                key: 'CUSTOMER_LEGAL_REPRESENTATIVE_DOCUMENT_NUMBER',
                label: 'Número do documento do representante legal',
            },

            { key: 'CUSTOMER_BILLING_NAME', label: 'Nome do responsável pelo faturamento' },
            { key: 'CUSTOMER_BILLING_EMAIL', label: 'E-mail do responsável pelo faturamento' },
            { key: 'CUSTOMER_BILLING_PHONE_NUMBER', label: 'Telefone do responsável pelo faturamento' },
            { key: 'CUSTOMER_BILLING_DDI', label: 'DDI do responsável pelo faturamento' },

            { key: 'CUSTOMER_DEPLOY_CONTACT_NAME', label: 'Nome do responsável pela implantação' },
            { key: 'CUSTOMER_DEPLOY_CONTACT_EMAIL', label: 'E-mail do responsável pela implantação' },
            { key: 'CUSTOMER_DEPLOY_CONTACT_PHONE_NUMBER', label: 'Telefone do responsável pela implantação' },
            { key: 'CUSTOMER_DEPLOY_CONTACT_DDI', label: 'DDI do responsável pela implantação' },
        ],
    },
    { label: '', options: [] },
    {
        label: 'Contato',
        options: [
            { key: 'CONTACT_TYPE', label: 'Tipo de Contato' },
            { key: 'CONTACT_DDI', label: 'DDI' },
            { key: 'CONTACT_NUMBER', label: 'Telefone do Contato' },
        ],
    },
    { label: '', options: [] },
    {
        label: 'Parcelas',
        options: [
            { key: 'DUE_DATE_SETUP', label: 'Data Vencimento Setup' },
            { key: 'DUE_DATE_MONTHLY', label: 'Data Vencimento Mensalidade' },
            { key: 'DISCOUNT_MONTHS_COUNT', label: 'Quantidade de Meses de Desconto' },
        ],
    },
];

export const REFERENCE_FIELD_OPTIONS = new EnumArray(
    ...REFERENCE_FIELD_OPTIONS_CREATE.flatMap(item => item.options),
);
